import { gql } from '@apollo/client';

export const GENERATE_EXCEPTION_DOWNLOAD_REPORT_FOR_WMS = gql`
    mutation GenerateExceptionDownloadReportForWms($filters: OrderFiltersTypeInput, $timezone: String, $warehouseId: Long) {
        generateExceptionDownloadReportForWms(filters: $filters, timezone: $timezone, warehouseId: $warehouseId)
    }
`;

export interface GenerateExceptionDownloadReportForWmsResponse {
    generateExceptionDownloadReportForWms: string;
}

export interface GenerateExceptionDownloadReportForWmsVariables {
    filters?: any;
    timezone?: string;
    warehouseId?: number;
}
